import { ChatBubbleBottomCenterTextIcon as AnnotationIcon } from '@heroicons/react/24/outline';
import { format } from 'date-fns';
import { useEffect, useRef, useState } from 'react';
import { FuneralServiceTribute } from '../../types';
import TributePanel from './TributePanel';

const Tribute = ({ tribute }: { tribute: FuneralServiceTribute }) => (
  <div className="tribute">
    <div className="tribute-inner-container">
      <div className="tribute-message">{tribute.tribute}</div>
      <div className="flex flex-col gap-4">
        <div className="tribute-name">{tribute.name}</div>
        <div className="tribute-location">{tribute.location}</div>
        <div className="tribute-date">{format(new Date(tribute.created_at), 'dd MMM y')}</div>
      </div>
    </div>
    <div className="image-container">{tribute?.photo_url && <img className="tribute-image" src={tribute?.photo_url} alt="Tribute Photo" />}</div>
  </div>
);

const ServiceTribute = ({
  tributes,
  serviceHash,
  hasPrimaryContact,
  canAddTributes,
}: {
  tributes?: FuneralServiceTribute[];
  serviceHash: string;
  hasPrimaryContact: boolean;
  canAddTributes: boolean;
}) => {
  let searchParams = new URLSearchParams(window.location.search);

  const sendTribute = searchParams.get('send_tribute');

  const [tributePanel, setTributePanel] = useState(sendTribute && parseInt(sendTribute) > 0);

  const tributePanelRef = useRef();

  useEffect(() => {
    if (tributePanelRef.current && tributePanel) {
      tributePanelRef?.current?.scrollIntoView({ behavior: 'smooth' });
    }
  }, [tributePanelRef.current, tributePanel]);

  return (
    <div>
      <div className="tributes-title">
        <h3 className="tributes-list-title">Tributes</h3>

        {canAddTributes ? (
          !tributePanel && (
            <button
              className="leave-tribute-button"
              onClick={() => {
                setTributePanel(true);
              }}
            >
              <AnnotationIcon className="leave-tribute-icon" />
              Leave a tribute
            </button>
          )
        ) : (
          <div className="cannot-add-tributes-message">Tributes are no longer being accepted for this service.</div>
        )}
      </div>
      <div ref={tributePanelRef} />
      <TributePanel open={tributePanel} onClose={() => setTributePanel(false)} serviceHash={serviceHash} hasPrimaryContact={hasPrimaryContact} />
      {tributes?.length ? (
        <div className="tributes-container">
          {tributes?.map((tribute) => <Tribute key={`${tribute.name}-${tribute.created_at}`} tribute={tribute} />)}
        </div>
      ) : (
        <div className="tributes-container">
          <div className="tribute">
            <div className="tribute-inner-container">
              <div className="tribute-message">There are no tributes yet.</div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ServiceTribute;
